export default {
    SET_SELECTED_COMMUNE(state, commune) {
        state.selectedCommune = commune;
    },
    SET_COMMUNE_DATA(state, communeData) {
        state.communeData = communeData;
    },
}
